'use client';

import { createContext } from 'react';
import { getGlobalDataMapping } from './GlobalDataMapping';
import { DataMapper, SupportedDataSources } from '../types';

export const DataMapperContext = createContext<{
  cmsBasedDataMapping: DataMapper;
  CURRENT_CMS: SupportedDataSources;
}>({
  cmsBasedDataMapping: getGlobalDataMapping(),
  CURRENT_CMS: SupportedDataSources.KontentAi,
});
